import React from 'react';
import Login from './pages/Login.js';
import Home from './pages/Home.js';
import ForgotPassword from './pages/ForgotPassword.js';
import LoadingScreen from './common/LoadingScreen.js';
import base, { firebase } from './rebase.js';
import 'semantic-ui-css/semantic.min.css';
import './App.css';

import { 
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {authUser: null, loadingUser: true};
  
    this.adminChangeTourOperator = this.adminChangeTourOperator.bind(this);
  }

  adminChangeTourOperator(top) {
    if (!this.state.authUser) return;
    var authUser = Object.assign({}, this.state.authUser);
    authUser.tour_operator = top;
    this.setState({authUser: authUser});
  }

  componentWillMount() {
    firebase.auth().onAuthStateChanged(function(authUser) {
      if (authUser) {
        authUser.getIdToken(true);
        base.fetch('users/'+ authUser.uid, {}).then(function(userdata) {
          authUser.tour_operator = userdata.tour_operator;
          authUser.display_name = userdata.display_name;
          base.fetch('tour_operators/' + userdata.tour_operator, {}).then(function(topdata) {
            if (topdata.name === "TRANSAVIA") {
              authUser.isAdmin = true;
            }
            authUser.topData = topdata;
            this.setState({authUser: authUser, loadingUser: false});        
          }.bind(this));
        }.bind(this));
      } else {
        this.setState({authUser: authUser, loadingUser: false});
      }
    }.bind(this));
  }

  render() {
    if (this.state.loadingUser) {
      return <LoadingScreen />
    }

    return (
      <Router> 
        <Switch>
          <PrivateRoute        path="/home"            component={Home}            authUser={this.state.authUser} changeTop={this.adminChangeTourOperator} />       
          <OnlyLoggedOutRoute  path="/login"           component={Login}           authUser={this.state.authUser} />
          <OnlyLoggedOutRoute  path="/forgotpassword"  component={ForgotPassword}  authUser={this.state.authUser} />
          <Redirect            from="*"      to="/home" />
        </Switch>
      </Router>
    );
  }
}

const PrivateRoute = ({ component: Component, authUser: authUser, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      authUser ? (                     
        <Component authUser={authUser} {...props} {...rest} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

const OnlyLoggedOutRoute = ({ component: Component, authUser: authUser, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      authUser ? (                     
        <Redirect
          to={{
            pathname: "/home",
            state: { from: props.location }
          }}
        />
      ) : (
        <Component authUser={authUser} {...props} />
      )
    }
  />
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js